module.exports = __webpack_public_path__ + "f4f209d9235ff8520ef73bd75ae939b0.svg";